import React, { useEffect, useRef, useState } from "react";
import "./signatureCanvas.css";
import SignatureCanvas from "./signatureCanvas";
import ModalConfirm from "../../components/ui/modal/ModalConfirm";
import { Toast } from "primereact/toast";
import { showMsg } from "../../utils/Constants.tsx";
import CandadoImg from "/src/assets/images/candado.png";
import { useNavigate } from "react-router-dom";

function SignatureCanvasImpl({ setShowModalSignature }: any) {
  const sigCanvas: any = useRef(null);
  const navigate = useNavigate();
  const [trimmedDataURL, setTrimmedDataURL] = useState(null);
  const [base64DataImg, setBase64DataImg] = useState("");
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const numDocument = useRef<string>();
  const isMounted = useRef(false);
  const toast = useRef(null);
  const [needFetchingDoc, setNeedFetchingDoc] = useState(false);

  const [goHome, setGoHome] = useState(false);
  useEffect(() => {
    if (goHome) {
      navigate("/", { replace: true });
    }
  }, [goHome]);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!isMounted) setShowModalSignature(false);
  }, []);

  useEffect(() => {
    // Pequeño delay para asegurar que el DOM de móvil (especialmente en modales)
    // se haya renderizado con sus dimensiones finales.
    const timer = setTimeout(() => {
      // Accedemos directamente al método de la CLASE a través de la ref
      if (sigCanvas.current) {
        // Nota: Si usas la clase que definimos antes, el método es _resizeCanvas o resize
        // Asegúrate de que el método no sea privado.
        sigCanvas.current._resizeCanvas();
      }
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  function clear() {
    if (sigCanvas.current) {
      sigCanvas.current.clear();
    }
  }

  /*function trim() {
    if (sigCanvas.current.isEmpty() == true) {
      showMsg(toast, "warn", "Advertencia", "Debe registrar la firma");
      return null;
    }
    setTrimmedDataURL(
      sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"),
    );
    setBase64DataImg(sigCanvas.current.getTrimmedCanvas().toDataURL("base64"));
  }*/

  function trim() {
    if (sigCanvas.current.isEmpty()) return;

    const rawCanvas = sigCanvas.current.getTrimmedCanvas();

    // Create a smaller "target" canvas
    const scaledCanvas = document.createElement("canvas");
    const ctx = scaledCanvas.getContext("2d");

    if (!ctx) return;

    // Set your desired MAX dimensions (e.g., 400px wide)
    const maxWidth = 600;
    const scaleFactor = maxWidth / rawCanvas.width;
    scaledCanvas.width = maxWidth;
    scaledCanvas.height = rawCanvas.height * scaleFactor;

    // Draw the big signature into the small canvas
    ctx.drawImage(rawCanvas, 0, 0, scaledCanvas.width, scaledCanvas.height);

    // This PNG will be significantly lighter
    const lightBase64 = scaledCanvas.toDataURL("image/png");

    setBase64DataImg(lightBase64);
  }

  function sendData() {
    if (sigCanvas.current.isEmpty() == true) {
      showMsg(toast, "warn", "Advertencia", "Debe registrar la firma");
      return null;
    }
    if ((numDocument.current ?? "").length == 6) {
      setShowModalConfirm(true);
    } else {
      showMsg(toast, "warn", "Advertencia", "Debe ingresar su clave numérica");
    }
  }

  function decodeBase64Image(dataString: string) {
    let encodedImage = dataString.split(",")[1];
    return encodedImage;
  }

  const handleInputNumDoc = (e: any) => {
    numDocument.current = e.target.value;
  };

  return (
    <div id="containerFirma" className="container">
      <Toast ref={toast} />
      {showModalConfirm ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <ModalConfirm
            header="Confirmación"
            text="¿Estás seguro de guardar esta firma?"
            show={true}
            setShowModalConfirm={setShowModalConfirm}
            setDocId={0}
            setNeedFetchingDoc={setNeedFetchingDoc}
            data={base64DataImg}
            jsonDestination="nvafirmadigital"
            data2={numDocument.current}
            setGoHome={setGoHome}
          />
        </div>
      ) : null}

      <div
        className="sigContainer"
        style={{ display: base64DataImg.length > 0 ? "none" : "flex" }}
      >
        <SignatureCanvas
          canvasProps={{ className: "sigCanvas", width: 800, height: 300 }}
          clearOnResize={false}
          ref={sigCanvas}
        />

        <div style={{ marginTop: "30px", alignSelf: "center" }}>
          <button
            style={{ marginRight: "20px" }}
            className="base-button-noback"
            onClick={clear}
          >
            Limpiar
          </button>
          <button className="base-button" onClick={trim}>
            Registrar
          </button>
        </div>
      </div>

      {/* trimmedDataURL ? (
        <img
          id="imgSign"
          style={{ width: "150px", height: "100px" }}
          className="sigImage"
          alt="signature"
          src={trimmedDataURL}
        />
      ) : null */}

      {/*<p>{base64DataImg}</p>*/}
      {/*<img
        src={`data:image/png;base64,${decodeBase64Image(base64DataImg)}`}
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.style.display = "none";
        }}
      />*/}

      <div
        style={{
          textAlign: "center",
          margin: "40px",
          display: base64DataImg === "" ? "none" : "",
        }}
      >
        <h2>PASO 2</h2>
        <h3>
          Ingresa una clave numérica de seis dígitos, para asociar a tu firma
        </h3>

        <img alt="" src={CandadoImg}></img>
        <div style={{ marginTop: "20px" }}>
          <label>Clave numérica: </label>
          <input
            title=""
            placeholder="Clave de 6 dígitos"
            type="text"
            maxLength={6}
            minLength={6}
            onChange={(e) => handleInputNumDoc(e)}
            value={numDocument.current}
          />
          <div
            style={{
              padding: "40px",
              height: "20px",
              textAlign: "center",
            }}
          >
            <button
              style={{
                width: "200px",
                height: "25px",
                fontSize: "12px",
                fontWeight: "bold",
              }}
              className="buttonform"
              onClick={() => {
                sendData();
              }}
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignatureCanvasImpl;
